import * as React from 'react'
import { TaskSummaryFieldConnected } from './TaskSummaryFieldConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskSummaryFieldExamples = () => {
  return (
    <div className="TaskSummaryFieldExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskSummaryFieldConnected />
      </Provider>
    </div>
  )
}
